module.exports = __webpack_public_path__ + "static/media/icon_conformity-data-issue.2e6ec559.svg";